import { render } from "./DashboardScreen3.vue?vue&type=template&id=7ef407a0&scoped=true"
import script from "./DashboardScreen3.vue?vue&type=script&lang=js"
export * from "./DashboardScreen3.vue?vue&type=script&lang=js"

import "./DashboardScreen3.vue?vue&type=style&index=0&id=7ef407a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef407a0"]])

export default __exports__